export default __webpack_public_path__ + "static/media/fabricated-parts.d57d7ceb.png";